import * as yup from 'yup';
import { SELECTING_REASON_REQUIRED, ACKNOWLEDGEMENT_REQUIRED, } from '../../constants/field-error-messages';
export var validationSchema = yup.object().shape({
    closeAccountReason: yup.string().required(SELECTING_REASON_REQUIRED.message),
    acknowledgement: yup
        .bool()
        .required(ACKNOWLEDGEMENT_REQUIRED.message)
        .oneOf([true], ACKNOWLEDGEMENT_REQUIRED.message),
});
